import prismic from "@prismicio/client";

// The access token is injected at build time (Doppler -> REACT_APP_PRISMIC_ACCESS_TOKEN) so it is
// not committed to the repository. Note that any REACT_APP_* value is inlined into the client
// bundle by CRA, so this must stay a read-only Prismic token.
export const PrismicClient = () => {
  const client = prismic.client('https://bokamera.prismic.io/api/v2', {
    accessToken: process.env.REACT_APP_PRISMIC_ACCESS_TOKEN,
  });

  return client;
};
